export default {
  /**
   * @description 配置默认显示在浏览器标签的title
   */
  title: '泛域官网',
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    dev: 'http://localhost:3300',
    pro: 'http://47.114.73.131',
  }
}
